import React from 'react'

const AnimationMotionBlur = ({ color = '#CFE1FC' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 10"
      width="100%"
      height="100%"
      preserveAspectRatio="xMidYMid meet"
      style={{ display: 'block' }}
    >
      <circle fill={color} stroke={color} strokeWidth="2" r="4" cx="5" cy="5">
        <animate attributeName="cx" calcMode="spline" dur="2s" values="5;35;35;5;5" keySplines="0 .1 .5 1;0 .1 .5 1;0 .1 .5 1;0 .1 .5 1" repeatCount="indefinite" begin="0" />
      </circle>
      <circle fill={color} stroke={color} strokeWidth="2" opacity=".8" r="4" cx="5" cy="5">
        <animate attributeName="cx" calcMode="spline" dur="2s" values="5;35;35;5;5" keySplines="0 .1 .5 1;0 .1 .5 1;0 .1 .5 1;0 .1 .5 1" repeatCount="indefinite" begin="0.05s" />
      </circle>
      <circle fill={color} stroke={color} strokeWidth="2" opacity=".6" r="4" cx="5" cy="5">
        <animate attributeName="cx" calcMode="spline" dur="2s" values="5;35;35;5;5" keySplines="0 .1 .5 1;0 .1 .5 1;0 .1 .5 1;0 .1 .5 1" repeatCount="indefinite" begin=".1s" />
      </circle>
      <circle fill={color} stroke={color} strokeWidth="2" opacity=".4" r="4" cx="5" cy="5">
        <animate attributeName="cx" calcMode="spline" dur="2s" values="5;35;35;5;5" keySplines="0 .1 .5 1;0 .1 .5 1;0 .1 .5 1;0 .1 .5 1" repeatCount="indefinite" begin=".15s" />
      </circle>
      <circle fill={color} stroke={color} strokeWidth="2" opacity=".2" r="4" cx="5" cy="5">
        <animate attributeName="cx" calcMode="spline" dur="2s" values="5;35;35;5;5" keySplines="0 .1 .5 1;0 .1 .5 1;0 .1 .5 1;0 .1 .5 1" repeatCount="indefinite" begin=".2s" />
      </circle>
    </svg>
  )
}

export default AnimationMotionBlur
